import { render } from "./AddSalesmanShopModal.vue?vue&type=template&id=fa60c75a"
import script from "./AddSalesmanShopModal.vue?vue&type=script&lang=js"
export * from "./AddSalesmanShopModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__